import React from 'react';

import Typography from 'widget/shared/ui/Typography';
import {
  TypographyColor,
  TypographySize,
  TypographyTag,
  TypographyWeight
} from 'widget/shared/ui/Typography/types';
import { WidgetContactFormMode } from 'widget/entities/config';

import styles from './SubmissionIntro.module.scss';

export type SubmissionIntroProps = {
  mode: WidgetContactFormMode;
  title: string;
  subtitle?: string | null;
};

const SubmissionIntro: React.FC<SubmissionIntroProps> = ({
  mode,
  title,
  subtitle
}) => {
  const isBeforeDialog = mode === WidgetContactFormMode.beforeDialog;

  return (
    <div className={styles['intro']}>
      <Typography
        tag={TypographyTag.h3}
        weight={TypographyWeight.semiBold}
        size={isBeforeDialog ? TypographySize.l : TypographySize.m}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          tag={TypographyTag.p}
          color={TypographyColor.secondary}
          size={TypographySize.m}
        >
          {subtitle}
        </Typography>
      )}
    </div>
  );
};

export default React.memo(SubmissionIntro);
